// extracted by mini-css-extract-plugin
module.exports = {"overlay-wrapper":"AddApps__overlay-wrapper___gXual"};